<template>
  <div>
    <div v-if="downloadType === 'Setup (Win)'">
      <i>{{
        $t("With this download you install or update Media Hoarder on your PC_")
      }}</i>
    </div>
    <div v-if="downloadType === 'Portable (Win)'">
      <i>{{
        $t(
          "With this download you get a portable version of Media Hoarder which runs anywhere, e_g_ on thumb drives_"
        )
      }}</i>
    </div>
    <div v-if="downloadType === 'Setup (_deb)'">
      <i>{{
        $t(
          "With this download you get a Debian package_ Install it with dpkg, gdebi or Software Center_"
        )
      }}</i>
    </div>
    <div v-if="downloadType === 'Setup (_rpm)'">
      <i>{{
        $t(
          "With this download you get an RPM package_ Install it with the RPM Package Manager_"
        )
      }}</i>
    </div>
    <div v-if="downloadType === 'AppImage'">
      <i>{{ $t("With this download you get an AppImage_") }}</i>
    </div>
    <div v-if="downloadType === 'Snap Package'">
      <i>{{ $t("With this download you get a Snap package_") }}</i>
    </div>
    <div v-if="downloadType === 'Portable (Linux)'">
      <i>{{
        $t(
          "With this download you get a portable version of Media Hoarder which runs anywhere, e_g_ on thumb drives_"
        )
      }}</i>
    </div>
    <div v-if="downloadType === 'Apple Disk Image (.dmg)'">
      <i>{{ $t('With this download you get a _dmg file containing Media Hoarder_') }}</i>
    </div>
  </div>
</template>

<script>
export default {
  name: "DownloadDescription",

  props: {
    downloadType: String,
  },

  data: () => ({}),
};
</script>

<style lang="sass">
#customer-reviews
  .v-carousel__controls
    background: transparent

    .base-body
      line-height: 2
</style>
